export function buildSessionTogglePayload({ phoneNumber, botNumber, organisationId, isOngoing }) {
  return {
    phone_number: phoneNumber,
    bot_number: botNumber,
    company_id: organisationId,
    intervene: !isOngoing,
    session_start: !isOngoing,
  };
}
